import { createFileRoute } from '@tanstack/react-router';

import { LoadingPage } from '@nesso/ui/blocks/loading-page';

import { BillingSettingsPage, billingSettingsBeforeLoad } from '@/pages/settings/billing-settings';

export const Route = createFileRoute('/settings/billing-settings')({
    beforeLoad: billingSettingsBeforeLoad,
    component: BillingSettingsPage,
    pendingComponent: LoadingPage,
});
